import React from "react";
import { Button, Menu, MenuItem, Position } from "@blueprintjs/core";
import { Tooltip } from "antd";
import { useItinMode, useRaOpenModal } from "../../store/model-misc";
import "moment-timezone";
import {
  GflightsMenuItem,
  makeFlightsSearchUrl,
} from "./flights-link-menu-items";
import { useSendEmailFactory } from "./send-airline-email";
import { StyledPopoverWrapper } from "../popover-wrapper";
import "styled-components/macro";
import { useBoolean } from "../../helpers/useBoolean";
import { TripNote } from "../trip-note";

function SendEmailMenuItem({ data }) {
  const sendEmail = useSendEmailFactory(data);

  return (
    <MenuItem
      data-testid="send_email_menuitem"
      icon="envelope"
      text="Send Email"
      onClick={sendEmail}
    />
  );
}

function NoteMenuItem({ tripId, showTripNotes }) {
  return (
    <MenuItem
      data-testid={`open_trip_note__${tripId}`}
      icon="annotation"
      text="Trip Notes"
      onClick={showTripNotes.setTrue}
      shouldDismissPopover={false}
    />
  );
}

export function ReportActionButtonCellRenderer({ data, context }) {
  const itinMode = useItinMode();

  const tableName = context.tableName;
  const isSuspendsTable = tableName === "suspends";
  const isOppsTable = tableName === "opportunities";
  const isFloppsTable = tableName === "flopptions";

  const allowSendEmail =
    (isOppsTable || isFloppsTable) && itinMode === "oneway";
  const allowReportSuspend = isOppsTable || isFloppsTable;
  const allowReportBooked = isSuspendsTable || isOppsTable || isFloppsTable;
  const allowReportSkipping = isSuspendsTable || isOppsTable || isFloppsTable;
  const allowVisitGflights = isSuspendsTable || isOppsTable || isFloppsTable;

  // const airlineCode = AIRLINE_CODES[extractMainCarrier({ data, itinMode })];
  const gflightsUrl =
    data["Google Flights URL"] || makeFlightsSearchUrl("gflights", data);
  // const kayakUrl = data["Kayak URL"];
  // const kiwiUrl = makeFlightsSearchUrl("kiwi", data);
  const openDrawer = useRaOpenModal();

  const reportFactory = (actionName) => () => {
    const fullAction = { actionName: actionName, snapshot: data };
    openDrawer(fullAction);
  };
  const reportBooked = reportFactory("booked");
  const reportSkipping = reportFactory("skipping");
  const reportSuspend = reportFactory("suspend");

  const tripId = data["TripId"];
  const humanTripId = data["group#-tour#"] ?? data["[Book] Tourcenter"];

  const showTripNotes = useBoolean(false);

  let thePopoverMenu = (
    <Menu large>
      {allowSendEmail && <SendEmailMenuItem data={data} context={context} />}
      {allowReportBooked && (
        <MenuItem
          data-testid="report_booked_menuitem"
          icon="thumbs-up"
          text="Booked it"
          onClick={reportBooked}
        />
      )}
      {allowReportSkipping && (
        <MenuItem
          data-testid="report_skipping_menuitem"
          icon="thumbs-down"
          text="Skipping it"
          onClick={reportSkipping}
        />
      )}
      {allowReportSuspend && (
        <MenuItem
          data-testid="report_suspend_menuitem"
          icon="pause"
          text="Suspend"
          onClick={reportSuspend}
        />
      )}
      {allowVisitGflights && <GflightsMenuItem gflightsUrl={gflightsUrl} />}
      {/*{airlineCode !== "WN" && <KayakMenuItem kayakUrl={kayakUrl} />}*/}
      {/*<KiwiMenuItem kiwiUrl={kiwiUrl} />*/}
      <NoteMenuItem tripId={tripId} showTripNotes={showTripNotes} />
    </Menu>
  );
  if (showTripNotes.value) {
    thePopoverMenu = (
      <TripNote
        tripId={tripId}
        humanTripId={humanTripId}
        showTripNotes={showTripNotes}
      />
    );
  }
  const onPopoverClosed = async (ev) => {
    showTripNotes.setFalse();
  };
  return (
    <span>
      <StyledPopoverWrapper
        canEscapeKeyClose
        content={thePopoverMenu}
        position={Position.RIGHT_BOTTOM}
        onClosed={onPopoverClosed}
      >
        <Tooltip
          title="Report an action"
          placement="topLeft"
          mouseEnterDelay={1.5}
        >
          <Button
            data-testid={`${context.tableName}_report_action_button__${data.id}`}
            data-testclass={`${context.tableName}_report_action_button`}
            minimal
            small
            icon="take-action"
            large={false}
            intent="primary"
          />
        </Tooltip>
      </StyledPopoverWrapper>
    </span>
  );
}

function extractMainCarrier({ data, itinMode }) {
  return itinMode === "oneway" ? data.carrier_0 : data.f1__carrier_0;
}
